import { render, staticRenderFns } from "./reworkProcess.vue?vue&type=template&id=136fb2fc&scoped=true"
import script from "./reworkProcess.vue?vue&type=script&lang=js"
export * from "./reworkProcess.vue?vue&type=script&lang=js"
import style0 from "./reworkProcess.vue?vue&type=style&index=0&id=136fb2fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136fb2fc",
  null
  
)

export default component.exports